import classnames from "classnames";
import {
  faArrowUpRightFromSquare,
  faDesktop,
  faMobile,
  faRocket,
  faTablet,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { GrigoraEditorContext } from "../context";
import LoaderSmall from "../../loader/loadersmall";
import "./index.scss";
import {
  EditPopover,
  Popover,
  PopoverAnchor,
  PopoverContent,
  TextInput,
  Tooltip,
} from "../../input";
import { ReactComponent as Logo } from "../../../assets/grigoraWhite.svg";
import { GrigoraDashboardContext } from "../../dashboard/context";
import { useEditor } from "@craftjs/core";
import { motion } from "framer-motion";
import { isJsonString } from "../../helpers";
import Debug from "./debug";
import UndoRedo from "./undo-redo";
import { Mobile, Tablet } from "../../../assets/ui-icons";
import { isMac } from "../../utils";
import { WhiteLabelContext } from "../../whitelabel";
import { WEBCLIP_URL } from "../../app";

function MenuContent({ title, shortcut, ...props }) {
  return (
    <button
      {...props}
      className="flex w-full justify-between items-center px-2 py-2 hover:bg-gray-200 focus-visible:bg-gray-200 outline-none duration-200 rounded-[3px] cursor-pointer"
    >
      <span>{title}</span>
      <span>
        {shortcut && (
          <span className="text-grigora-base text-gray-500">
            {isMac() ? shortcut.mac : shortcut.windows}
          </span>
        )}
      </span>
    </button>
  );
}

function HomeMenu({ setRunEditorTutorial }) {
  const { projectID } = useContext(GrigoraDashboardContext);

  const { __whitelabel__ } = useContext(WhiteLabelContext) ?? {};

  const {
    updatePages,
    keyboardShortcutModal,
    setKeyboardShortcutModal,
    isHomeMenuOpen,
    setIsHomeMenuOpen,
  } = useContext(GrigoraEditorContext);

  const { query } = useEditor((state) => ({
    enabled: state.options.enabled,
    state: state,
  }));

  const navigate = useNavigate();

  return (
    <Popover
      placement="bottom"
      open={isHomeMenuOpen}
      onOpenChange={setIsHomeMenuOpen}
    >
      <PopoverAnchor
        onClick={() => setIsHomeMenuOpen((v) => !v)}
        position="top"
        style={{}}
        className="text-ui-blue w-10 h-10 flex items-center justify-center cursor-pointer duration-200 hover:bg-gray-200 border-r p-1"
      >
        <img
          className="w-full h-full object-contain"
          src={__whitelabel__("icon", WEBCLIP_URL)}
        />
      </PopoverAnchor>
      <PopoverContent className="!z-[10000] !shadow-editor-floating-elements">
        <div className="cursor-default !text-grigora-base p-1 w-[200px] text-center ">
          <MenuContent
            title={"Save"}
            onClick={(e) => {
              e.preventDefault();
              updatePages(query);
              setIsHomeMenuOpen(false);
            }}
            shortcut={
              {
                // windows: "Ctrl + `",
                // mac: "⌘`",
              }
            }
          />
          <MenuContent
            title={"Settings"}
            onClick={(e) => {
              e.preventDefault();
              navigate(`/site/${projectID}/settings/general`);
              setIsHomeMenuOpen(false);
            }}
            shortcut={
              {
                // windows: "Ctrl + `",
                // mac: "⌘`",
              }
            }
          />
          <MenuContent
            title={"Keyboard shortcuts"}
            onClick={(e) => {
              e.preventDefault();
              setIsHomeMenuOpen(false);
              setKeyboardShortcutModal(true);
            }}
            shortcut={
              {
                // windows: "Ctrl + `",
                // mac: "⌘`",
              }
            }
          />
          <MenuContent
            onClick={(e) => {
              e.preventDefault();
              setRunEditorTutorial(true);
              setIsHomeMenuOpen(false);
            }}
            title={"Run Editor Tutorial"}
            shortcut={
              {
                // windows: "Ctrl + `",
                // mac: "⌘`",
              }
            }
          />
          <MenuContent
            onClick={(e) => {
              e.preventDefault();
              navigate(`/site/${projectID}/`);
              setIsHomeMenuOpen(false);
            }}
            title={"Exit"}
            shortcut={
              {
                // windows: "Ctrl + `",
                // mac: "⌘`",
              }
            }
          />
        </div>
      </PopoverContent>
    </Popover>
  );
}

export default HomeMenu;
